module.exports = require("@scure/bip32");